var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "permission-popup" }, [
    _c("div", { staticClass: "head" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "popup-title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.locales("push_permission_title")) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _c("div", { staticClass: "pic" }, [
        _c("img", { attrs: { src: _vm.img, alt: "" } }),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "popup-text text",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "popup-btn blue-btn",
          on: { click: _vm.clickPermission },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.locales("request_permission")) + "\n    "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }